<template>
	<section>
		<div class="filtering-bar">
			<input type="text" ref="servicesFiltering" v-model="filteringInput"  spellcheck="false" autocorrect="off" autocomplete="off" :placeholder="T('search')">
			<i class="material-icons" @click="$refs.servicesFiltering.focus();">search</i>
		</div>
		<div class="d21-events-query">
			<div class="d21-date-wrapper d21-date-range-wrapper">
				<Datepicker id="date-from" v-model="selectedRange" :noClearButton="true" :no-label="true" :no-button-now="true" :range="true" :only-date="true" :min-date="minDate" :no-header="false" :no-shortcuts="true" :label="T('please_select_date')" color="#006bb7" formatted="ll" output-format="YYYY-MM-DD" :auto-close="true" /><i class="d21-calendar-icon material-icons">today</i>
			</div>
		</div>
		<Loader>
			<div v-if="isLoaded" class="d21-events-container" id="d21-query-products">
				<ul class="d21-events-select" v-if="!selectedEvent">
					<li v-for="product in filteredProducts" :key="product._uuid">
						<span>{{ V(product,"Content.Name", "display_name") }}</span>
						<span class="locality" v-if="product.Content.Description" v-html="product.Content.Description"></span>
						<span class="note" v-if="product.Content.Notes">{{ product.Content.Notes }}</span>
						<ul>
							<li v-for="(event, eventIndex) in product.events" :key="eventIndex">
								<div :class="{ 'd21-event-disabled': event.Capacity <= 0 || (event.deadlineInfo && !event.deadlineInfo.isReached)}" @click="eventSelected(event, product)">
									<span class="date">{{ getEventDate(event) }}</span>
									<span class="time">{{ getEventTime(event) }}</span>
									<span class="capacity" v-if="event.Capacity <= 0">{{ T("ticketing_event_booked_out") }}</span>
									<span class="capacity" v-else :class="getStatusClass(event)">{{ T("ticketing_tickets_available", event.Capacity) }}</span>
									<span class="deadline" v-if="event.deadlineInfo && !event.deadlineInfo.isReached && !event.deadlineInfo.isAfter">{{ T("event_bookable_from").format(event.deadlineInfo.dateString) }}</span>
								</div>
							</li>
						</ul>
					</li>
				</ul>

				<div class="d21-query-selectedEvent" v-if="selectedEvent" @click="unset">
					<span v-if="selectedEvent !== null && selectedEvent.Type === 'AlwaysAvailableProduct'">
						<span class="name">{{ V(selectedEvent,"Content.Name", "display_name") }}</span>
						<span class="date">{{ T("selling.isalwaysavailable") }}</span>
						<span><i class="material-icons">edit_calendar</i></span>
					</span>
					<span v-else>
						<span class="name">{{ V(selectedProduct,"Content.Name", "display_name") }}</span>
						<span v-if="selectedProduct.Content.Description" class="locality" v-html="selectedProduct.Content.Description"></span>
						<span v-if="selectedProduct.Content.Notes" class="note">{{ selectedProduct.Content.Notes }}</span>
						<span class="date">{{ getEventDate(selectedEvent) }}</span>
						<span class="time">{{ getEventTime(selectedEvent) }}</span>
						<span><i class="material-icons">edit_calendar</i></span>
					</span>
				</div>

				<div class="tariffs d21-query-products" v-if="selectedEvent">
					<label class="text-header">
						{{ T("OneTicketing_how_many_people") }}
						<div :class="statusClass" v-if="!Reservation.Info.Capacity.AllUnavailable && selectedEvent.CapacityStatus !== ''">
							<i class="material-icons">confirmation_number</i>{{ T("OneTicketing_availableTickets") + ":" }} {{selectedEvent.Capacity}}
						</div>
						<div class="d21-capacity-allUnavailable" v-if="Reservation.Info.Capacity.AllUnavailable">
							<i class="material-icons">confirmation_number</i>{{ T("OneTicketing_noTickets_available") }}
						</div>
					</label>
					<ProductTariffs :product="selectedEvent" />
				</div>
			</div>
		</Loader>
	</section>
</template>

<script>
	import moment from "moment";
	import baseMixin from "@/mixins/base";
	import Datepicker from "vue-ctk-date-time-picker";
	import Loader from "./ui/loader.vue";
	import ProductTariffs from "./partial/product-tariffs.vue";
	import {
		EventBus
	} from "../scripts/_eventBus.js";

	export default {
		mixins: [baseMixin],
		components: {
			Datepicker,
			Loader,
			ProductTariffs
		},
		props: {
			selectedMode: {
				type: String,
			}
		},
		data() {
			return {
				selectedRange: {
					start: moment().format("YYYY-MM-DD"),
					end: moment().add(6, "months").format("YYYY-MM-DD")
				},
				selectedEvent: null,
				selectedProduct: null,
				searchTimeout: null,
				isLoaded: false,
				filteringInput: ""
			}
		},
		created() {
			//if default end range set use that one
			if (this.Channel.Settings.DefaultEventBookableFrom) {
				this.selectedRange.end = moment().add(this.Channel.Settings.DefaultEventBookableFrom.Time, this.Channel.Settings.DefaultEventBookableFrom.TimeUnit).format("YYYY-MM-DD");
			}
		},
		computed: {
			statusClass() {
				return this.getStatusClass(this.selectedEvent);
			},
			minDate() {
				return moment().format("YYYY-MM-DD");
			},
			eventsList() {
				return this.selectedMode === 'AlwaysAvailableProducts' ? this.alwaysAvailableProducts : this.defaultEvents;
			},
			visibleProducts() {
				// get all products in specified range - distinctify them
				const distinctProducts = [...new Set(this.Reservation.Products.map(c => c.Product))];
				var visibleProducts = distinctProducts.map(productUuid => {
					// Get the product from info (there are all products)
					const product = this.Reservation.fn.getProduct(productUuid);
					// Get the events in specified range
					product.events = this.Reservation.Products.filter(c => c.Product === productUuid);

					//add Info of deadline
					product.events.forEach(e => {
						e.deadlineInfo = this.deadlineInfo(product.Attributes, e);
					});

					//remove events there deadline has passed
					product.events = product.events.filter(e => !e.deadlineInfo.isAfter);

					return product;
				});

				return visibleProducts.filter(p => p.events.length);
			},
			filteredProducts(){
				if (this.visibleProducts == null) return [];
				return this.filteringInput != "" ? 
					this.visibleProducts.filter(s => s.Content.Name.toLowerCase().includes(this.filteringInput.trim().toLowerCase())) : 
					this.visibleProducts;
			},
		},
		methods: {
			unset() {
				this.visibleProducts.forEach(p => p.events.forEach(e => e.isSelected = false));
				this.selectedEvent = null;
				this.selectedProduct = null;
			},
			getEventDate(event) {
				var date = moment(event.Period.From);
				return date.format("ddd, DD.MM.YYYY");
			},
			eventSelected(event, product) {
				if (event.Capacity <= 0 || (event.deadlineInfo && !event.deadlineInfo.isReached)) return;

				var newValue = !event.isSelected;
				product.events.forEach(e => e.isSelected = false);
				event.isSelected = newValue;

				if (!event.isSelected) {
					this.selectedEvent = null;
					this.selectedProduct = null;
					return;
				}

				if (this.selectedEvent === null || this.selectedEvent !== event) {
					const timeFrame = this.Channel.AllPeriods.map(c => c.TimeFrames).flat().find(c => c._uuid === event.Period.Timeframe_uuid);
					this.selectedEvent = event;
					this.Reservation.Query.From.Date = moment(event.Period.From, "YYYY-MM-DD HH:mm");
					this.Reservation.From.Date = moment(event.Period.From, "YYYY-MM-DD HH:mm");

					this.Reservation.EventDate = event;
					this.Reservation.EventDate.Content = {
						Name: product.Content.Name
					};

					this.Reservation.From.StartTime = timeFrame.Times.Start;
					this.Reservation.From.EndTime = timeFrame.Times.End;

					this.Reservation.Mode = "Dates";
					this.Reservation.From.TimeFrame = timeFrame;
				}

				this.selectedProduct = product;
			},
			getEventTime(event) {
				const startDate = moment(event.Period.From);
				const endDate = moment(event.Period.Until);

				return `${startDate.format("HH:mm")} - ${endDate.format("HH:mm")} ${ this.T("o_clock") }`;
			},
			resetData() {
				// reset reservation
				if (this.Reservation.Info) this.Reservation.Info.Capacity.AllUnavailable = false;
				this.Reservation.Alternatives = [];
				this.Reservation.Products = [];
				this.Reservation.Discounts = [];

				// Reset local data
				this.selectedProduct = null;
				this.selectedEvent = null;
			},
			search() {
				if (this.searchTimeout !== null) window.clearTimeout(this.searchTimeout);
				this.isLoaded = false;
				this.searchTimeout = window.setTimeout(() => {
					EventBus.$emit("loading_start");

					this.resetData();

					let from = this.selectedRange.start;
					let until = moment(this.selectedRange.end).add(1, "days").format("YYYY-MM-DD");
					let command = `/availability/events?from=${from}&until=${until}&productsVersionCode=display_name`;
					this.apiRequest(command, null, "GET", response => {
						if (response.Value) {
							if (response.Value.Discounts) {
								response.Value.Discounts.forEach(d => {
									d.isSelected = false;
									d.errorMessage = "";
								});
							} else {
								response.Value.Discounts = [];
							}

							// set defaults
							this.Reservation.Info = response.Value.Info;

							//
							response.Value.Result.forEach(r => {
								r.Tariffs.forEach(t => {
									const tariff = this.Reservation.fn.getTariff(t.Tariff);
									t.Units = [];
									t.NumberOfPersons = tariff.Restrictions && tariff.Restrictions.Occupancy && tariff.Restrictions.Occupancy.Min ? tariff.Restrictions.Occupancy.Min : 1;
									t.Occupancy = [];
								});
								r.Occupancy = [];
							});

							this.Reservation.Products = response.Value.Result;
							this.Reservation.Discounts = response.Value.Discounts;

							// preselect event if there is only one
							if (this.Reservation.Products.length === 1) {
								const product = this.Reservation.fn.getProduct(this.Reservation.Products[0].Product);
								const event = this.Reservation.Products[0];

								this.$nextTick(() => this.eventSelected(event, product));
							}
						} else {
							this.Reservation.Info = null;
							this.Reservation.Products = [];
							this.Reservation.Discounts = [];
						}
						EventBus.$emit("loading_end");
						this.isLoaded = true;
					});
				}, 100);
			},
			getStatusClass(event) {
				return "d21-capacity-status d21-capacity-status--" + event.CapacityStatus.toLowerCase();
			},
			deadlineInfo(attributes, event) {
				var info;
				var bookableFrom = moment(event.Period.From).subtract(attributes.DeadlineMinutesFrom, "m");
				var bookableUntil = moment(event.Period.From).subtract(attributes.DeadlineMinutesUntil, "m");

				info = {
					isReached: moment().isSameOrAfter(bookableFrom) && moment().isSameOrBefore(bookableUntil),
					isAfter: moment().isAfter(bookableUntil),
					//use to 12h format for en-U
					dateString: this.hub.culture === "en-US" ? bookableFrom.format("DD. MMM YYYY hh:mm A") : bookableFrom.format("DD. MMM YYYY HH:mm")
				};

				return info;
			}
		},

		watch: {
			selectedRange: {
				immediate: true,
				handler(val) {
					if (val && val.start && val.end) {
						this.search();
					}
				}

			}
		}
	}
</script>